<template lang="pug">
  .section
    .container
      .columns.is-centered
        .column.is-8
          .hero
            .hero-body
              //h3.title.is-5.has-text-centered Verifying your email address
              .has-text-centered.is-relative.p-6(v-if="verified === undefined") 
                em-loading(:active="true" :is-full-page="false")
                p.is-size-5 {{ $t('email_verify.verification_in_progress') }}
                
              .has-text-centered(v-else-if="verified === true")
                p.has-text-success
                  span.icon.is-large
                    i.mdi.mdi-36px.mdi-check-circle-outline
                p.title.is-3.has-text-success(v-t="'email_verify.success_title'")
                p.subtitle(v-t="'email_verify.success_subtitle'")

                p(v-t="'email_verify.redirecting'")
              .has-text-centered(v-else-if="verified === false") 
                div(v-if="alreadyVerified === true")
                  p
                    span.icon.is-large
                      i.mdi.mdi-36px.mdi-alert-outline
                  p.title.is-3(v-t="'email_verify.already_verified_title'")
                  p.subtitle(v-t="'email_verify.already_verified_subtitle'")
                  p
                    router-link.button.is-primary(to="/signin") 
                      span.icon
                        i.mdi.mdi-key
                      span {{ $t('signup.actions.signin') }}
                div(v-else)
                  p.has-text-danger
                    span.icon.is-large
                      i.mdi.mdi-36px.mdi-close-circle-outline
                  p.title.is-3.has-text-danger(v-t="'email_verify.invalid_link_title'")
                  p.subtitle(v-html="$t('email_verify.invalid_link_subtitle')")
                  .buttons.is-centered
                    a.button.is-warning(href="mailto:support@emly.co" v-t="'actions.contact_support'")
                    router-link.button.is-primary(to="/signin") 
                      span.icon
                        i.mdi.mdi-key
                      span {{ $t('signup.actions.signin') }}
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'EmailVerify',
  props: {
    verificationKey: {type: String, required: true},
    userId: {type: String, required: true}
  },
  data() {
    return {
      verified: undefined,
      alreadyVerified: undefined
    }
  },
  async created() {
    this.verify()
  },
  methods: {
    ...mapActions('auth', ['verifyEmail']),
    async verify() {
      try {
        await this.verifyEmail(this.verificationKey)
        // await this.$store.dispatch('company/fetch')

        window.fbq && window.fbq('track', 'CompleteRegistration')
        this.verified = true
        setTimeout(() => {
          this.$router.push('/dashboard')
        }, 2000)
      } catch (err) {
        if (err && err.body && err.body.code === 'EMAIL_ALREADY_VERIFIED') {
          this.alreadyVerified = true
        } else if (err && err.body && err.body.code === 'INVALID_VERIFICATION_KEY') {
          this.alreadyVerified = false
        } else {
          this.$handleAPIError(err)
        }
        this.verified = false
      }
    }
  }
}
</script>
